const asyncImport = require('util/asyncImport').default;
const { trackGtm, trackGtm4 } = require('util/functions');

module.exports = {
	async init() {
		const closeError = this.root.querySelector('.button-widget--close');

		if (closeError)
			closeError.addEventListener('click', this.hideWarning.bind(this));

		this.description = this.root.querySelector('.button-widget--description');
		this.link = this.root.querySelector('.button-widget--button');
		await asyncImport(this, 'throttle');

		this.link.addEventListener('click', () => {
			trackGtm({
				eventCategory: 'cta',
				eventAction: 'componentTypeVariable',
				eventLabel: `${this.link.textContent} | ${this.link.href}`,
			});
			trackGtm4({
				event: 'GA4_event_c_cta',
				widget_name: 'V3-Button-widget',
				widget_title: this.description.textContent,
				link_text: this.link.textContent.trim(),
				link_url: this.link.href,
				button_type: '',
			});
		});

		this.event = this.throttle(this.onScroll.bind(this), 200);
		window.addEventListener('scroll', this.event);
		this.onScroll();
	},
	onScroll() {
		const level = this.root.offsetTop + this.root.offsetHeight + 50;
		const windowBottom = window.pageYOffset + window.innerHeight;
		if (level < windowBottom) {
			this.description.classList.add('active');
			window.removeEventListener('scroll', this.event);
		}
	},
	hideWarning() {
		const modalError = this.root.querySelector('.button-widget--warning');
		modalError.style.display = 'none';
	},
};
